define("shared/components/shared/ember-drop-multi-select", ["exports", "@ember/component", "@ember/object", "@ember/runloop", "@ember/service", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _runloop, _service, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _performSearch;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/runloop",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div
    class="o--btn o--btn--outline o--btnDrop e--optionSelect--toggle
      {{@dropTarget}}
      {{if @isDisabled 'o--btn--disabled'}}"
    data-test-id="multi-select"
    ...attributes
  >
    <span><b>{{@label}}</b> {{this.selectedOptionsText}}</span>
    {{svg-jar "caret-down" class="o--icon o--btnDrop__icon"}}
  </div>
  
  <Shared::Ui::EmberDrop
    @constrainToScrollParent={{true}}
    @constrainToWindow={{true}}
    @contentSelector=".e--optionSelect--drop"
    @openOn="click"
    @position="bottom left"
    @target={{concat "." @dropTarget}}
    as |emberDrop|
  >
    <div class="o--dropWrapper e--optionSelect--drop {{@wrapperClass}}">
      {{! Drop Header }}
  
      {{#unless @searchDisabled}}
        <div class="o--dropHeader">
          <div class="o--inputAction--light">
            {{svg-jar "search" class="o--icon o--inputAction__icon--left"}}
            <Input
              @type="search"
              @value={{this.searchTerm}}
              class="o--inputAction__input u--p__r__md"
              id="multiselect-search"
              placeholder={{t "shared_words.search"}}
              {{on "input" this.searchOptions}}
            />
            {{#if this.hasSearchTerm}}
              <Shared::Ui::Button @onClick={{this.clearOptionSearch}} @variant="unstyled">
                {{svg-jar "close" class="o--icon o--inputAction__icon--right u--fadeIn--right"}}
              </Shared::Ui::Button>
            {{/if}}
          </div>
        </div>
      {{/unless}}
  
      {{! Drop Body }}
      <div class="o--dropBody">
        <ul class="o--dropBody__list {{@listClass}}">
          {{#each @options as |option|}}
            <li class="o--dropBody__item {{@listItemClass}}">
              <Shared::EmberDropMultiSelectItem
                @closeEmberDrop={{emberDrop.closeAction}}
                @handleClick={{@handleClick}}
                @hasSearchTerm={{this.hasSearchTerm}}
                @option={{option}}
                @searchedOptions={{this.searchedOptions}}
                @selectedOptions={{@selectedOptions}}
              />
            </li>
          {{/each}}
        </ul>
      </div>
    </div>
  </Shared::Ui::EmberDrop>
  */
  {
    "id": "k7+w3GTC",
    "block": "[[[11,0],[16,0,[29,[\"o--btn o--btn--outline o--btnDrop e--optionSelect--toggle\\n    \",[30,1],\"\\n    \",[52,[30,2],\"o--btn--disabled\"]]]],[24,\"data-test-id\",\"multi-select\"],[17,3],[12],[1,\"\\n  \"],[10,1],[12],[10,\"b\"],[12],[1,[30,4]],[13],[1,\" \"],[1,[30,0,[\"selectedOptionsText\"]]],[13],[1,\"\\n  \"],[1,[28,[35,1],[\"caret-down\"],[[\"class\"],[\"o--icon o--btnDrop__icon\"]]]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[8,[39,2],null,[[\"@constrainToScrollParent\",\"@constrainToWindow\",\"@contentSelector\",\"@openOn\",\"@position\",\"@target\"],[true,true,\".e--optionSelect--drop\",\"click\",\"bottom left\",[28,[37,3],[\".\",[30,1]],null]]],[[\"default\"],[[[[1,\"\\n  \"],[10,0],[15,0,[29,[\"o--dropWrapper e--optionSelect--drop \",[30,6]]]],[12],[1,\"\\n\"],[1,\"\\n\"],[41,[51,[30,7]],[[[1,\"      \"],[10,0],[14,0,\"o--dropHeader\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"o--inputAction--light\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"search\"],[[\"class\"],[\"o--icon o--inputAction__icon--left\"]]]],[1,\"\\n          \"],[8,[39,5],[[24,0,\"o--inputAction__input u--p__r__md\"],[24,1,\"multiselect-search\"],[16,\"placeholder\",[28,[37,6],[\"shared_words.search\"],null]],[4,[38,7],[\"input\",[30,0,[\"searchOptions\"]]],null]],[[\"@type\",\"@value\"],[\"search\",[30,0,[\"searchTerm\"]]]],null],[1,\"\\n\"],[41,[30,0,[\"hasSearchTerm\"]],[[[1,\"            \"],[8,[39,8],null,[[\"@onClick\",\"@variant\"],[[30,0,[\"clearOptionSearch\"]],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,1],[\"close\"],[[\"class\"],[\"o--icon o--inputAction__icon--right u--fadeIn--right\"]]]],[1,\"\\n            \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[1,\"    \"],[10,0],[14,0,\"o--dropBody\"],[12],[1,\"\\n      \"],[10,\"ul\"],[15,0,[29,[\"o--dropBody__list \",[30,8]]]],[12],[1,\"\\n\"],[42,[28,[37,10],[[28,[37,10],[[30,9]],null]],null],null,[[[1,\"          \"],[10,\"li\"],[15,0,[29,[\"o--dropBody__item \",[30,11]]]],[12],[1,\"\\n            \"],[8,[39,11],null,[[\"@closeEmberDrop\",\"@handleClick\",\"@hasSearchTerm\",\"@option\",\"@searchedOptions\",\"@selectedOptions\"],[[30,5,[\"closeAction\"]],[30,12],[30,0,[\"hasSearchTerm\"]],[30,10],[30,0,[\"searchedOptions\"]],[30,13]]],null],[1,\"\\n          \"],[13],[1,\"\\n\"]],[10]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[5]]]]]],[\"@dropTarget\",\"@isDisabled\",\"&attrs\",\"@label\",\"emberDrop\",\"@wrapperClass\",\"@searchDisabled\",\"@listClass\",\"@options\",\"option\",\"@listItemClass\",\"@handleClick\",\"@selectedOptions\"],false,[\"if\",\"svg-jar\",\"shared/ui/ember-drop\",\"concat\",\"unless\",\"input\",\"t\",\"on\",\"shared/ui/button\",\"each\",\"-track-array\",\"shared/ember-drop-multi-select-item\"]]",
    "moduleName": "shared/components/shared/ember-drop-multi-select.hbs",
    "isStrictMode": false
  });
  let EmberDropMultiSelectComponent = _exports.default = (_class = (_performSearch = /*#__PURE__*/new WeakSet(), class EmberDropMultiSelectComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _performSearch);
      _initializerDefineProperty(this, "intl", _descriptor, this);
      _initializerDefineProperty(this, "hasSearchTerm", _descriptor2, this);
      _initializerDefineProperty(this, "searchTerm", _descriptor3, this);
      _initializerDefineProperty(this, "searchedOptions", _descriptor4, this);
      _defineProperty(this, "debounceInMs", 250);
    }
    get selectedOptionsText() {
      return this.args.selectedOptions.length ? this.args.selectedOptions.join(', ') : this.intl.t('shared_words.all');
    }
    clearOptionSearch(event) {
      event.stopPropagation();
      this.searchTerm = '';
      this.searchedOptions = [];
      this.hasSearchTerm = false;
    }
    performActionAndCloseDrop(action, closeEmberDrop) {
      action();
      closeEmberDrop();
    }
    searchOptions(_ref) {
      let {
        target: {
          value
        }
      } = _ref;
      this.searchTerm = value;
      this.hasSearchTerm = this.searchTerm.length > 0;
      (0, _runloop.debounce)(this, _classPrivateMethodGet(this, _performSearch, _performSearch2), this.debounceInMs);
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "hasSearchTerm", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "searchTerm", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "searchedOptions", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  }), _applyDecoratedDescriptor(_class.prototype, "clearOptionSearch", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearOptionSearch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "performActionAndCloseDrop", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "performActionAndCloseDrop"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "searchOptions", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "searchOptions"), _class.prototype)), _class);
  function _performSearch2() {
    this.searchedOptions = this.args.options?.filter(option => {
      const optionArray = new Set(option.name.split(' ').map(optionPart => optionPart.toLowerCase()));
      const searchTermArray = new Set(this.searchTerm.split(' ').map(searchTerm => searchTerm.toLowerCase()));
      const intersection = [...optionArray].filter(optionArrayItem => searchTermArray.has(optionArrayItem));
      return Boolean(intersection.length);
    }).map(searchOption => searchOption.name);
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, EmberDropMultiSelectComponent);
});